export { default } from "./CardVod"
